!
<template>
  <div
    class="backgound wrapper wrapper-full-page overflow-hidden d-flex flex-column"
  >
    <div id="particles-js"></div>
    <img
      src="static/img/central-gym150x150.webp"
      class="mx-auto mb-1 mt-5 over logo"
      style="width: 150px"
      alt=""
      slot="header"
    />
    <div class="card mx-auto col-md-6 shadow-lg mb-5 bg-white rounded px-0">
      <div class="card-header text-center bg-success text-white">
        <h2 class="card-title mb-4">¡Tu pago está siendo procesado!</h2>
      </div>
      <div class="card-body my-2">
        <p class="card-text col-md-10 mx-auto">
          Hola <span class="lead">{{ payer || "Place Holder" }}</span
          >! <br />Gracias por tu pago. Estamos procesando tu transacción.<br />
          Recibirás un correo electrónico de confirmación una vez que se haya
          verificado tu pago.<br />
          Este proceso puede tardar unos minutos. Si tienes alguna duda, no
          dudes solicitar ayuda en recepción.
        </p>
        <div class="col-md-10 mx-auto border">
          <div class="d-flex fle-row">
            <div class="col-3 col-md-2"><p class="mb-1">Plan:</p></div>
            <div class="col-9">
              <p class="mb-1">{{ membership || "Placeholder placeholder" }}</p>
            </div>
          </div>
          <div class="d-flex fle-row">
            <div class="col-3 col-md-2"><p class="mb-1">Gym:</p></div>
            <div class="col-9">
              <p class="mb-1">{{ gymName || "Placeholder placeholder" }}</p>
            </div>
          </div>
          <div class="d-flex fle-row">
            <div class="col-3 col-md-2"><p class="mb-1">Sede:</p></div>
            <div class="col-9">
              <p class="mb-1">{{ branchName || "Placeholder placeholder" }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-muted text-center mb-4">
        © 2024 CentralGym. Todos los derechos reservados.
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
  },
  data() {
    return {
      membership: "",
      payer: "",
      gymName: "",
      branchName: "",
    };
  },
  methods: {
    initParticles() {
      particlesJS("particles-js", {
        particles: {
          number: { value: 100, density: { enable: true, value_area: 800 } },
          color: { value: "#ffffff" },
          shape: { type: "circle" },
          opacity: { value: 0.5, random: true },
          size: { value: 3, random: true },
          move: {
            enable: true,
            speed: 1,
            direction: "none",
            random: true,
            out_mode: "out",
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
          },
          modes: {
            repulse: { distance: 100, duration: 0.4 },
            push: { particles_nb: 4 },
          },
        },
      });
    },
  },
  mounted() {
    this.initParticles();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // Ej query esperada localhost:8080/successfull-payment?membership=nombremembresia&payer=EstebanHormazabal&gymName=GymDemo&branchName=SucursalDemo
      if (
        to.query &&
        to.query.membership &&
        to.query.payer &&
        to.query.gymName &&
        to.query.branchName
      ) {
        console.log("validao");
        console.log(to.query);
        vm.membership = to.query.membership;
        vm.payer = to.query.payer;
        vm.gymName = to.query.gymName;
        vm.branchName = to.query.branchName;
      } else {
        vm.$swal.fire({
          title: "SOLICUTD INCOMPLETA",
          icon: "warning",
          text: 'Estas intentando ingresar con una solicitud incompleta',
        })
        .then(res => {
          vm.$router.push('/login')
        });
      }
    });
  },
};
</script>

<style>
.backgound {
  background-color: #000000;
}
.card {
  z-index: 100;
}
#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
}
</style>
